import { useState } from 'react'

import AccordionItem from '@/components/ui/accordion-item'
import HeadingWithAnchor from '@/components/heading-with-anchor'

import { slugify } from '@/utils/strings'
import { TypeSectionAccordion } from '@/types/ctf'

type AccordionProps = TypeSectionAccordion<'WITHOUT_UNRESOLVABLE_LINKS'>['fields']

export default function Accordion({
  internalName,
  title,
  items,
  allowMultipleToBeOpen,
  isOpenByDefault = false,
  color,
}: AccordionProps) {
  const [openIndices, setOpenIndices] = useState<number[]>(isOpenByDefault ? [0] : [])

  const handleToggle = (isOpen: boolean, index: number) => {
    if (allowMultipleToBeOpen) {
      if (isOpen) {
        setOpenIndices((prev) => [...prev, index])
      } else {
        setOpenIndices((prev) => prev.filter((i) => i !== index))
      }
    } else {
      setOpenIndices(isOpen ? [index] : [])
    }
  }

  return (
    <div className="bw-section-accordion my-8 [.bw-section-accordion_&]:mt-0">
      {title && <HeadingWithAnchor type="h2" id={slugify(internalName)} title={title} />}
      <div>
        {items?.map(
          (item, index) =>
            item && (
              <AccordionItem
                key={item.sys.id}
                {...item.fields}
                color={color}
                content={item.fields.content || ''}
                isOpen={openIndices.includes(index)}
                onToggle={(isOpen) => handleToggle(isOpen, index)}
              />
            )
        )}
      </div>
    </div>
  )
}
